import {
  CError,
} from '../consoleMixin'
import {
  getAxiosClient,
} from './axios-client'

/**
 * @typedef {import('./js-doc').V2MaintenanceMode} V2MaintenanceMode
 * @typedef {import('./js-doc').V2MaintenanceModeUpdateRequest} V2MaintenanceModeUpdateRequest
 */


class Maintenance {
  constructor () {
    this.baseURL = `maintenance`
  }

  /**
   *   @returns {Promise<V2MaintenanceMode>} - V2 response body
   */
  async get () {
    try {
      const result = (await (await getAxiosClient(this.baseURL)).get(``))
      return result?.data
    }
    catch (error) {
      CError(`Could not retrieve maintenance status from V2 API`, error)
      throw error
    }
  }

  /**
   * Create a reserve for the client specified in the constructor
   * @param {V2MaintenanceModeUpdateRequest} payload - V2 update maintenance request body
   * @returns {Promise<V2MaintenanceMode>} - V2 response body
   */
  async update (payload) {
    const result = (await(await getAxiosClient(this.baseURL)).post(``, {
      ...payload,
    }))
    return result?.data
  }
}

export default Maintenance
